module.exports = __webpack_public_path__ + "img/my-business.498bf962.png";